const MOBILE_APP_USER_AGENT_TOKENS = [
  "EquipeChat-Teste",
  "EquipeChat-iOS",
  "EquipeChat-Visita",
  "EquipeChat-Visita-iOS",
  // "EquipeChat-Desktop" removido — Desktop usa window.EquipeChatDesktop.shell e deve exibir layout PWA
];

const hasDesktopShellBridge = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.EquipeChatDesktop?.forceMobileLayout === true;
};

const hasForceMainAppFlag = () => {
  if (
    typeof window !== "undefined" &&
    window.ENV &&
    String(window.ENV.REACT_APP_FORCE_MAIN_APP || "").toLowerCase() === "true"
  ) {
    return true;
  }

  return String(process.env.REACT_APP_FORCE_MAIN_APP || "").toLowerCase() === "true";
};

const hasEquipeChatUserAgent = () => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const userAgent = String(navigator.userAgent || "").toLowerCase();

  return MOBILE_APP_USER_AGENT_TOKENS.some((token) =>
    userAgent.includes(String(token || "").toLowerCase())
  );
};

const isNativeCapacitorRuntime = () => {
  if (typeof window === "undefined") {
    return false;
  }

  if (typeof window.Capacitor?.isNativePlatform === "function") {
    return window.Capacitor.isNativePlatform();
  }

  const platformHints = [
    window.Capacitor?.platform,
    window.Capacitor?.platformId,
    typeof window.Capacitor?.getPlatform === "function"
      ? window.Capacitor.getPlatform()
      : "",
  ]
    .map((value) => String(value || "").trim().toLowerCase())
    .filter(Boolean);

  return platformHints.some((value) => value !== "web");
};

// PWA instalado (atalho na tela inicial — display-mode: standalone/fullscreen ou iOS navigator.standalone)
const isInstalledPwa = () => {
  if (typeof window === "undefined") return false;
  // Desktop shell nunca é tratado como app móvel
  if (window.EquipeChatDesktop) return false;
  // iOS "Add to Home Screen"
  if (window.navigator.standalone === true) return true;
  // Android / outros — Web App Manifest standalone/fullscreen
  const queries = ["(display-mode: standalone)", "(display-mode: fullscreen)"];
  return queries.some((q) => {
    try { return window.matchMedia(q).matches; } catch (_) { return false; }
  });
};

// Diferente de isEquipeChatMobileApp() (usada pra decidir o LAYOUT do
// cabeçalho em vários lugares, e por isso é ampla de propósito - também vira
// true pra CRM instalado como PWA no navegador do desktop e pro shell
// EquipeChatDesktop) - esta aqui é estrita, só pra decisões que fazem
// sentido SÓ no celular de verdade do motoboy/atendente (ex: pílulas de
// valor/dia coladas no nome do cliente, pensadas pra ver rápido em pé na
// rua - não fazem sentido/pedido do usuário 26/08/2026 removidas em
// qualquer coisa rodando num desktop, PWA instalado ou não).
export const isRealMobileNativeApp = () =>
  hasEquipeChatUserAgent() || isNativeCapacitorRuntime();

// 23/09/2026 — É um COMPUTADOR? Só o PONTEIRO decide: mouse/trackpad
// (hover + ponteiro fino) é computador; dedo (celular/tablet) não é.
// NÃO usar largura de janela aqui: no Windows com escala de tela em 125%/150%
// (o caso do usuário) uma janela de ~1000px reais vira ~800px de CSS e o PWA
// voltava pro layout de celular — foi exatamente o "ainda está do mesmo
// jeito" relatado. Quem cuida de janela estreita é o próprio layout
// responsivo, igual já acontece no Chrome.
export const isDesktopDevice = () => {
  if (typeof window === "undefined") return false;
  try {
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  } catch (_) {
    return false;
  }
};

export const isEquipeChatMobileApp = () => {
  if (hasForceMainAppFlag()) {
    return true;
  }

  if (hasDesktopShellBridge()) {
    return true;
  }

  if (hasEquipeChatUserAgent()) {
    return true;
  }

  if (isNativeCapacitorRuntime()) {
    return true;
  }

  // 23/09/2026 — relatado com print: o CRM instalado como PWA NO COMPUTADOR
  // abria no layout de CELULAR (barra inferior Cadastro/Cobrança/Chats, sem
  // a sidebar), enquanto a mesma conta no Chrome abria no layout de
  // computador. A causa era esta linha: bastava estar INSTALADO pra virar
  // "app móvel", sem olhar o aparelho. Agora o PWA só conta como app móvel
  // num aparelho móvel — num computador ele fica idêntico ao Chrome, que é
  // o que o usuário pediu. Isso vale pro app inteiro de propósito (são ~19
  // arquivos lendo esta função: cabeçalho, lista, campo de mensagem), senão
  // a tela ficaria metade num layout e metade no outro.
  return isInstalledPwa() && !isDesktopDevice();
};

export default isEquipeChatMobileApp;
